<template>
  <div>
    <!-- Table Card -->
    <div class="card">
      <div class="card-body">
        <!-- Table Section -->
        <div class="table-responsive signal-table">
          <table class="table table-hover">
            <thead>
              <tr>
                <th 
                  @click="sortTable('first_name')" 
                  :class="{'sortable col-description': true, 'active': memberStore.sort_by === 'first_name'}">
                  <span>Name &nbsp;</span>
                  <i v-if="memberStore.sort_by === 'first_name' && memberStore.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="memberStore.sort_by === 'first_name' && memberStore.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('username')" 
                  :class="{'sortable col-description': true, 'active': memberStore.sort_by === 'username'}">
                  <span>Username &nbsp;</span>
                  <i v-if="memberStore.sort_by === 'username' && memberStore.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="memberStore.sort_by === 'username' && memberStore.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col">Access level</th>
                <th scope="col">Enabled</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in memberStore.paginatedData" :key="index">
                <td>{{ item.first_name }}&nbsp;{{ item.middle_name }}&nbsp;{{ item.last_name }}</td>
                <td>{{ item.username }}</td>
                <td>{{ item.role?.name }}</td>
                <td>
                  <i :class="item.enabled ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                </td>
                <td>
                  <EditMemberModal :member="item" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 分頁 -->
        <div class="pagination-wrapper">
          <div class="pagination-container">
            <button @click="changePage(1)" :disabled="memberStore.currentPage === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(memberStore.currentPage - 1)" :disabled="memberStore.currentPage === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
            <span>Page <input type="number" v-model.number="memberStore.currentPage" @change="changePage(memberStore.currentPage)" /> of {{ memberStore.totalPages }}</span>
            <button @click="changePage(memberStore.currentPage + 1)" :disabled="memberStore.currentPage === memberStore.totalPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(memberStore.totalPages)" :disabled="memberStore.currentPage === memberStore.totalPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
          </div>
          <div class="total-count">
            Displaying members {{ (memberStore.currentPage - 1) * memberStore.itemsPerPage + 1 }} – {{ Math.min(memberStore.currentPage * memberStore.itemsPerPage, memberStore.totalEntries) }} of {{ memberStore.totalEntries }}
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue'; // 確保這裡正確導入了 ref
import { useMemberStore } from '@/store/admin/member';
import EditMemberModal from '@/pages/staffMembers/EditMemberModal.vue'; // 修改導入路徑為正確的組件位置

const memberStore = useMemberStore();

onMounted(() => {
  changePage(1);
  memberStore.fetchMembers();
});

// 表格排序處理邏輯
const sortTable = (field) => {
  if (memberStore.sort_by === field) {
    memberStore.order = memberStore.order === 'asc' ? 'desc' : 'asc';
  } else {
    memberStore.sort_by = field;
    memberStore.order = 'desc';
  }
  memberStore.fetchMembers();
};

const changePage = (page) => {
  memberStore.changePage(page);
};
</script>

<style scoped>
.card {
  margin: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 20px;
  position: relative;
}

.no-results {
    margin: 15px;
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }

.table-responsive {
  margin-top: 20px;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table-hover tbody tr:hover {
  color: #495057;
  background-color: rgba(0, 0, 0, 0.075);
}

.table th.sortable {
  cursor: pointer;
  position: relative;
  padding-bottom: 10px;
}

.table th.sortable:hover {
  color: #00c962; /* Hover 時的文字顏色 */
}

.table th.active {
  color: #00c962; /* 當前排序的欄位文字顏色 */
}

/* 排序箭頭樣式 */
.sort-icon {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

/* 排序欄位下的綠色下劃線 */
.table th.active::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #00c962;
  position: absolute;
  bottom: 0;
  left: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.pagination-container {
  display: flex;
  align-items: center;
}

.pagination-container button {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: #8476f4;
}

.pagination-container span {
  margin: 0 10px;
}

.pagination-container input {
  width: 50px;
  text-align: center;
}

.total-count {
  font-size: 16px;
  color: #666;
}

.signal-table.table-responsive .table tbody tr td:nth-child(n+2) {
  min-width: 100px !important;
}

@media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }

  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
